import React, { Component } from "react";

import { HomeSlider, HomeDeals } from "../../Components/UI/UI";

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

class SpacielDeals extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
      const weather = response[0];

       // console.log( typeof weather);
      // console.log( weather);
    
      var weather2 = weather;

      
      if (typeof weather === 'string' && weather.includes("float")) {
        // Variable is a string
        // console.log('Is float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);

      
      } else if (typeof weather === 'object' && weather !== null) {
        // Variable is an object
        // console.log('Variable is an object');
        weather2 = weather.data;
        // console.log(weather2);
       
      } else if (typeof weather === 'string' && !weather.includes("float")){
        // console.log('Is NOt  float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);
     
      }

      //  else {
      //   // Variable is neither a string nor an object
      //   console.log('Variable is neither a string nor an object');
      // }

      this.setState({ 
        deadSeaWeather: weather2.deadsea.temperature,
        jerusalemWeather: weather2.jerusalem.temperature,
        telAvivWeather: weather2.telaviv.temperature,
        waterTemp: weather2.telaviv.water_temp,
      });

      // }
    });

    window.addEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <div className="page align-center page-SpacielDeals">
        <Menu />
        <HomeSlider
          isHomeSlider={true}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
        <HomeDeals />
        <Footer />
      </div>
    );
  }
}

export default SpacielDeals;



// WEBPACK FOOTER //
// ./src/Pages/SpacielDeals/SpacielDeals.js